import { Phone } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "../data/site";
import WhatsAppIcon from "./WhatsAppIcon";

export default function StickyMobileCTA() {
    return (
        <div
            data-testid="sticky-mobile-cta"
            className="fixed inset-x-0 bottom-0 z-50 border-t border-midnight/10 bg-white/95 p-3 backdrop-blur-xl md:hidden"
        >
            <div className="flex gap-2">
                <a
                    href={PHONE_TEL}
                    data-testid="sticky-call-button"
                    className="flex flex-1 animate-pulse-ring items-center justify-center gap-2.5 bg-emergency px-4 py-3.5 text-white transition-colors active:bg-emergency-dark"
                >
                    <Phone className="h-5 w-5" />
                    <span className="leading-none text-left">
                        <span className="block text-sm font-extrabold">Appel d'urgence</span>
                        <span className="mt-0.5 block text-[10px] font-semibold uppercase tracking-wider opacity-85">
                            Intervention 30 min
                        </span>
                    </span>
                </a>
                <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="sticky-whatsapp-button"
                    aria-label="WhatsApp"
                    className="flex w-16 items-center justify-center bg-[#25D366] text-white transition-colors active:bg-[#1eb856]"
                >
                    <WhatsAppIcon className="h-6 w-6" />
                </a>
            </div>
        </div>
    );
}
